var ButtonGroupButtonType;
(function (ButtonGroupButtonType2) {
  ButtonGroupButtonType2["GROUPED"] = "grouped";
  ButtonGroupButtonType2["SEPARATE"] = "separate";
})(ButtonGroupButtonType || (ButtonGroupButtonType = {}));

export { ButtonGroupButtonType };
